import {
  Box,
  Button,
  Collapse,
  Container,
  Input,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CustomButton from "../components/CustomButton";
import { COUNTRIES } from "../constants/Countries";
import { useParams } from "react-router-dom";
import { subscribeToNewsletter } from "../utils/brevoSubscribe";
import {
  cashButtons,
  joinButtons,
  kindButtons,
  toggleButtons,
} from "../constants";
import emailjs from "emailjs-com";

const Donations = () => {
  const { id } = useParams();
  const [toggleActive, setToggleActive] = useState(id || "give");
  const [activeButton, setActiveButton] = useState(1);
  const [activeCash, setActiveCash] = useState(1);
  const [selectedCode, setSelectedCode] = useState("");
  const [formTitle, setFormTitle] = useState("");
  const [sponsor, setSponsor] = useState("");
  const [service, setService] = useState("");
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");
  const [subText, setSubText] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
    hear: "",
    why_sponsor: "",
    organisation: "",
    where_from: "",
    what_service: "",
    audience: "",
    long_service: "",
    whatsapp_number: "",
    address: "",
    why_interested: "",
    questions: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Build a formatted string from all formData fields
    const message = Object.entries(formData)
      .map(
        ([key, value]) =>
          `${key.charAt(0).toUpperCase() + key.slice(1)}: ${value || "-"}`
      )
      .join("\n");

    const templateParams = {
      message, // Send a single message field
    };

    emailjs
      .send(
        "service_39iam0i",
        "template_x5mqy4s",
        templateParams,
        "I_E1yTQYUOTcAonLU"
      )
      .then((response) => {
        console.log("SUCCESS!", response.status, response.text);
        alert("Message Sent Successfully!");
        setFormData({
          name: "",
          surname: "",
          email: "",
          phone: "",
          code: "",
          hear: "",
          why_sponsor: "",
          organisation: "",
          where_from: "",
          what_service: "",
          audience: "",
          long_service: "",
          whatsapp_number: "",
          address: "",
          why_interested: "",
          questions: "",
        });
      })
      .catch((err) => {
        console.error("FAILED...", err);
        alert("Failed to send message. Please try again.");
      });
  };

  const handleSubmitt = async (e) => {
    e.preventDefault();

    const response = await fetch(
      "https://api.hsforms.com/submissions/v3/integration/submit/143406952/4b31cdc5-9443-489c-948d-660944fa4b45",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fields: [
            {
              name: "email",
              value: formData.email,
            },
            {
              name: "first name",
              value: formData.name,
            },
            {
              name: "last name",
              value: formData.surname,
            },
            {
              name: "phone",
              value: formData.phone,
            },
            {
              name: "how_did_you_hear_about_eagle",
              value: formData.hear,
            },
            {
              name: "hs_whatsapp_phone_number",
              value: formData.whatsapp_number,
            },
            {
              name: "organisation",
              value: formData.organisation,
            },
            {
              name: "address",
              value: formData.address,
            },
            {
              name: "questions",
              value: formData.questions,
            },
            {
              name: "what_training",
              value: formData.what_service,
            },
            {
              name: "why_sponsor",
              value: formData.why_sponsor,
            },
            {
              name: "how_long",
              value: formData.long_service,
            },
            {
              name: "why_interested",
              value: formData.why_interested,
            },
            {
              name: "primary_audience",
              value: formData.audience,
            },
            {
              name: "where_from",
              value: formData.where_from,
            },
          ],
        }),
      }
    );
    const result = await response.json();
    console.log(result);
    if (response.ok) {
      alert(
        "Thanks for subscribing to our newsletter. Check your inbox for the latest update!"
      );
    } else {
      alert(`Failed to subscribe: ${result.message || "Unknown error"}`);
    }
  };

  /*  <script src="https://js-eu1.hsforms.net/forms/embed/143406952.js" defer></script>
<div class="hs-form-frame" data-region="eu1" data-form-id="4b31cdc5-9443-489c-948d-660944fa4b45" data-portal-id="143406952"></div> */

  /*   const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("contact_service", "contact_form", form.current, {
        publicKey: "XvQqh4jPADZP5pjOs", // replace with your actual public key
      })
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error);
        }
      );
  }; */

  const handleSubscribe = async (e) => {
    e.preventDefault();

    const response = await fetch(
      "https://api.hsforms.com/submissions/v3/integration/submit/143406952/0d30c480-2f47-4d19-af7c-7121c18c7aa8",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fields: [
            {
              name: "email",
              value: email,
            },
          ],
        }),
      }
    );
    const result = await response.json();
    console.log(result);
    if (response.ok) {
      alert(
        "Thanks for subscribing to our newsletter. Check your inbox for the latest update!"
      );
    } else {
      alert(`Failed to subscribe: ${result.message || "Unknown error"}`);
    }
  };

  const handleCountryChange = (event) => {
    const countryCode = event.target.value;
    setFormData({ code: countryCode });
  };

  return (
    <>
      <Box sx={{ width: "100vw", pt: { xs: 10, md: 15 } }}>
        <Container
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", md: "40%" },
              height: "75%",
              mt: 2,
              mb: { xs: 5 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                border: "1px solid #DB5430",
                width: "210px",
                borderRadius: 2,
                mb: 3,
              }}
            >
              {toggleButtons.map((toggle) => (
                <Button
                  key={toggle.id}
                  sx={{
                    p: 0,
                    backgroundColor:
                      toggleActive === toggle.id ? "#DB5430" : "none",
                  }}
                  onClick={() => {
                    setToggleActive(toggle.id);
                    if (toggle.id === "give") {
                      setSponsor(toggle.defaultValue);
                      setActiveButton(cashButtons[0].id);
                      setSubText(cashButtons[0].text);
                      setFormTitle(cashButtons[0].title);
                    }
                    if (toggle.id === "inkind") {
                      setService(toggle.defaultValue);
                      setActiveButton(kindButtons[0].id);
                      setSubText(kindButtons[0].text);
                      setFormTitle(kindButtons[0].title);
                    }
                    if (toggle.id === "join") {
                      setRole(toggle.defaultValue);
                      setActiveButton(joinButtons[0].id);
                      setSubText(joinButtons[0].text);
                      setFormTitle(joinButtons[0].title);
                    }
                  }}
                >
                  <Typography
                    sx={{
                      color: toggleActive === toggle.id ? "#fff" : "#222222",
                      width: "70px",
                      borderRadius: 1,
                      textTransform: "none",
                      py: 1,
                    }}
                  >
                    {toggle.title}
                  </Typography>
                </Button>
              ))}
            </Box>

            {/* Give Forms Text */}
            <Typography
              variant="h2"
              sx={{ display: `${toggleActive === "give" ? "block" : "none"}` }}
            >
              Ways to donate
            </Typography>
            <Typography
              variant="body1"
              my={2.5}
              sx={{ display: `${toggleActive === "give" ? "block" : "none"}` }}
            >
              {subText || cashButtons[0].text}
            </Typography>

            {/* In Kind Forms Text */}
            <Typography
              variant="h2"
              sx={{
                display: `${toggleActive === "inkind" ? "block" : "none"}`,
              }}
            >
              Ways to donate
            </Typography>
            <Typography
              variant="body1"
              my={2.5}
              sx={{
                display: `${toggleActive === "inkind" ? "block" : "none"}`,
              }}
            >
              {subText || kindButtons[0].text}
            </Typography>

            {/* Join us form Text */}
            <Typography
              variant="h2"
              sx={{ display: `${toggleActive === "join" ? "block" : "none"}` }}
            >
              How to join
            </Typography>
            <Typography
              variant="body1"
              my={2.5}
              sx={{ display: `${toggleActive === "join" ? "block" : "none"}` }}
            >
              {subText || joinButtons[0].text}
            </Typography>
            <Collapse
              in={toggleActive === "give"}
              timeout="auto"
              unmountOnExit
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  width: "50%",
                  p: 0,
                }}
              >
                {cashButtons.map((button) => (
                  <Box key={button.id}>
                    <Button
                      sx={{ px: 0, display: "flex", flexDirection: "column" }}
                      onClick={() => {
                        setActiveCash(button.id);
                        setFormTitle(button.title);
                        setSponsor(button.code);
                        setSubText(button.text);
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: "secondary.light",
                          textAlign: "start",
                          width: "100%",
                          textTransform: "none",
                        }}
                      >
                        {button.title}
                      </Typography>
                      {activeCash === button.id && (
                        <hr
                          style={{
                            width: "100%",
                            borderStyle: "none",
                            border: "1px solid #DB5430",
                          }}
                        />
                      )}
                    </Button>
                  </Box>
                ))}
              </Box>
            </Collapse>

            <Collapse
              in={toggleActive === "inkind"}
              timeout="auto"
              unmountOnExit
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  width: "50%",
                  p: 0,
                }}
              >
                {kindButtons.map((button) => (
                  <Box key={button.id}>
                    <Button
                      sx={{ px: 0, display: "flex", flexDirection: "column" }}
                      onClick={() => {
                        setActiveButton(button.id);
                        setFormTitle(button.title);
                        setService(button.title);
                        setSubText(button.text);
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: "secondary.light",
                          textAlign: "start",
                          width: "100%",
                          textTransform: "none",
                        }}
                      >
                        {button.title}
                      </Typography>
                      {activeButton === button.id && (
                        <hr
                          style={{
                            width: "100%",
                            borderStyle: "none",
                            border: "1px solid #DB5430",
                          }}
                        />
                      )}
                    </Button>
                  </Box>
                ))}
              </Box>
            </Collapse>

            <Collapse
              in={toggleActive === "join"}
              timeout="auto"
              unmountOnExit
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  width: "50%",
                  p: 0,
                }}
              >
                {joinButtons.map((button) => (
                  <Box key={button.id}>
                    <Button
                      sx={{ px: 0, display: "flex", flexDirection: "column" }}
                      onClick={() => {
                        setActiveButton(button.id);
                        setFormTitle(button.title);
                        setRole(button.code);
                        setSubText(button.text);
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: "secondary.light",
                          textAlign: "start",
                          width: "100%",
                          textTransform: "none",
                        }}
                      >
                        {button.title}
                      </Typography>
                      {activeButton === button.id && (
                        <hr
                          style={{
                            width: "100%",
                            borderStyle: "none",
                            border: "1px solid #DB5430",
                          }}
                        />
                      )}
                    </Button>
                  </Box>
                ))}
              </Box>
            </Collapse>
          </Box>

          {/* Form Container */}
          <Box
            sx={{
              width: { xs: "100%", md: "50%" },
              backgroundColor: "secondary.main",
              borderRadius: 5,
              p: 2.5,
            }}
          >
            <Typography variant="h2" mb={2} color="primary.main">
              {formTitle || cashButtons[0].title}
            </Typography>
            <form>
              <Typography variant="body2" color="secondary.light">
                Name (required)
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 3,
                }}
              >
                <TextField
                  label="First Name"
                  variant="standard"
                  value={formData.name}
                  onChange={handleChange}
                  name="name"
                  sx={{
                    width: "45%",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
                <TextField
                  label="Last Name"
                  variant="standard"
                  value={formData.surname}
                  onChange={handleChange}
                  name="surname"
                  sx={{
                    width: "45%",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>
              <TextField
                label="Email"
                variant="standard"
                defaultValue="Zimbabwe"
                value={formData.email}
                onChange={handleChange}
                name="email"
                fullWidth
                sx={{
                  width: "45%",
                  "& .MuiInputBase-input": {
                    color: "#fff", // Text color inside input
                  },
                  "& .MuiInputLabel-root": {
                    color: "#fff", // Label color
                  },
                  "& .MuiInput-underline:hover:before": {
                    borderBottomColor: "#fff !important", // Bottom border on hover
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "#fff", // Bottom border color before focus
                  },
                }}
              />
              <Typography variant="body2" color="secondary.light">
                Country (required)
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 3,
                }}
              >
                <TextField
                  label="Country"
                  variant="standard"
                  select
                  defaultValue="Zimbabwe"
                  value={selectedCode}
                  onChange={handleCountryChange}
                  sx={{
                    width: "45%",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                >
                  {COUNTRIES.map((option) => (
                    <MenuItem key={option.name} value={option.code}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  label="Code"
                  defaultValue={"+263"}
                  variant="standard"
                  value={selectedCode}
                  /* disabled */
                  sx={{
                    width: "45%",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "transparent", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 2,
                }}
              >
                <TextField
                  label="Phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  fullWidth
                  variant="standard"
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>

              {/* How did you hear about Eagle? */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 2,
                }}
              >
                <TextField
                  label="How did you hear about Eagle?"
                  variant="standard"
                  multiline
                  value={formData.hear}
                  onChange={handleChange}
                  name="hear"
                  rows={4}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgba(255,255,255,0.3)",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff",
                    },
                  }}
                />
              </Box>

              {/* Give Form Fields */}
              {/* Why would you like to sponsor? */}
              <Box
                sx={{
                  display: `${toggleActive === "give" ? "flex" : "none"}`,
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 3,
                }}
              >
                <TextField
                  label={`Why would you like to sponsor ${sponsor}?`}
                  variant="standard"
                  multiline
                  rows={4}
                  value={formData.why_sponsor}
                  onChange={handleChange}
                  name="why_sponsor"
                  sx={{
                    width: "100%",
                    color: "#fff",
                    backgroundColor: "rgba(255,255,255,0.3)",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>

              {/* In Kind Form Fields */}
              {/* Organization Fields */}
              <Box
                sx={{
                  display: `${toggleActive === "inkind" ? "flex" : "none"}`,
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 3,
                }}
              >
                <TextField
                  label="Organization"
                  variant="standard"
                  value={formData.organisation}
                  onChange={handleChange}
                  name="organisation"
                  sx={{
                    width: "45%",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />

                <TextField
                  label="Where are you (and your organization) from?"
                  defaultValue={"+263"}
                  variant="standard"
                  value={formData.where_from}
                  onChange={handleChange}
                  name="where_from"
                  sx={{
                    width: "45%",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "transparent", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>

              {/* Why do you want to serve with eagle? */}
              <Box
                sx={{
                  display: `${toggleActive === "inkind" ? "flex" : "none"}`,
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 3,
                }}
              >
                <TextField
                  label={`Why would you like to sponsor ${sponsor}?`}
                  variant="standard"
                  multiline
                  rows={4}
                  value={formData.why_sponsor}
                  onChange={handleChange}
                  name="why_sponsor"
                  sx={{
                    width: "100%",
                    color: "#fff",
                    backgroundColor: "rgba(255,255,255,0.3)",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>

              {/* What service would you like to do with Eagle? */}
              <Box
                sx={{
                  display: `${toggleActive === "inkind" ? "flex" : "none"}`,
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 3,
                }}
              >
                <TextField
                  label={`What ${service} would you like to do with EAGLE?`}
                  variant="standard"
                  multiline
                  rows={4}
                  value={formData.what_service}
                  onChange={handleChange}
                  name="what_service"
                  sx={{
                    width: "100%",
                    color: "#fff",
                    backgroundColor: "rgba(255,255,255,0.3)",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>

              {/* Who is the primary audience for your service? */}
              <Box
                sx={{
                  display: `${toggleActive === "inkind" ? "flex" : "none"}`,
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 3,
                }}
              >
                <TextField
                  label={`Who is the primary audience for your ${service}?`}
                  variant="standard"
                  multiline
                  rows={4}
                  value={formData.audience}
                  onChange={handleChange}
                  name="audience"
                  sx={{
                    width: "100%",
                    color: "#fff",
                    backgroundColor: "rgba(255,255,255,0.3)",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>

              {/* How long would your service take? */}
              <Box
                sx={{
                  display: `${toggleActive === "inkind" ? "flex" : "none"}`,
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 3,
                }}
              >
                <TextField
                  label={`How long would your ${service} take?`}
                  variant="standard"
                  multiline
                  rows={4}
                  value={formData.long_service}
                  onChange={handleChange}
                  name="long_service"
                  sx={{
                    width: "100%",
                    color: "#fff",
                    backgroundColor: "rgba(255,255,255,0.3)",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>

              {/* Mentor/Learner Application Form */}
              {/* Email and Whatsapp Number */}
              <Box
                sx={{
                  display: `${toggleActive === "join" ? "flex" : "none"}`,
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 3,
                }}
              >
                <TextField
                  label="Email"
                  variant="standard"
                  defaultValue="Zimbabwe"
                  value={formData.email}
                  onChange={handleChange}
                  name="email"
                  sx={{
                    width: "45%",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />

                <TextField
                  label="Whatsapp Number"
                  variant="standard"
                  defaultValue="Zimbabwe"
                  value={formData.whatsapp_number}
                  onChange={handleChange}
                  name="whatsapp_number"
                  sx={{
                    width: "45%",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>

              {/* What is your address? */}
              <Box
                sx={{
                  display: `${toggleActive === "join" ? "flex" : "none"}`,
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 3,
                }}
              >
                <TextField
                  label={`Address(So we know how to connect you in with our Eagle network)`}
                  variant="standard"
                  multiline
                  rows={4}
                  value={formData.address}
                  onChange={handleChange}
                  name="address"
                  sx={{
                    width: "100%",
                    color: "#fff",
                    backgroundColor: "rgba(255,255,255,0.3)",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>

              {/* Why are you interested in becoming a role? */}
              <Box
                sx={{
                  display: `${toggleActive === "join" ? "flex" : "none"}`,
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 3,
                }}
              >
                <TextField
                  label={`Why are you interested in becoming a ${role}?`}
                  variant="standard"
                  multiline
                  rows={4}
                  value={formData.where_from}
                  onChange={handleChange}
                  name="where_from"
                  sx={{
                    width: "100%",
                    color: "#fff",
                    backgroundColor: "rgba(255,255,255,0.3)",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>

              {/* What are some questions you have? */}
              <Box
                sx={{
                  display: `${toggleActive === "join" ? "flex" : "none"}`,
                  flexDirection: "row",
                  alignItems: "column",
                  justifyContent: "space-between",
                  color: "white",
                  mb: 3,
                }}
              >
                <TextField
                  label={`What are some questions you have?`}
                  variant="standard"
                  multiline
                  rows={4}
                  value={formData.questions}
                  onChange={handleChange}
                  name="questions"
                  sx={{
                    width: "100%",
                    color: "#fff",
                    backgroundColor: "rgba(255,255,255,0.3)",
                    "& .MuiInputBase-input": {
                      color: "#fff", // Text color inside input
                    },
                    "& .MuiInputLabel-root": {
                      color: "#fff", // Label color
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#fff !important", // Bottom border on hover
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff", // Bottom border color before focus
                    },
                  }}
                />
              </Box>

              {/* Form Submit Button */}
              <CustomButton onClick={handleSubmitt}>
                <Typography variant="body1" sx={{ px: 2 }}>
                  Submit
                </Typography>
              </CustomButton>
            </form>
          </Box>
        </Container>

        {/*  Direct donate option  */}
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "40vh",
            justifyContent: "center",
            alignItems: "center",
            mb: { xs: 5, md: 0 },
            mt: { xs: 5, md: 0 },
          }}
        >
          <Typography variant="h7">Newsletter</Typography>
          <Typography
            variant="h2"
            maxWidth={"250px"}
            my={4}
            textAlign={"center"}
          >
            Subscribe to{" "}
            <span style={{ color: "#DB5430" }}>our newsletter</span>
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              justifyContent: "space-between",
              alignItems: "center",
              width: { xs: "100%", md: "40%" },
            }}
          >
            <Input
              variant="outlined"
              placeholder="Enter your email address"
              sx={{
                color: "#222222",
                width: { xs: "100%", md: "60%" },
                my: { xs: 2, md: 0 },
              }}
              onChange={(e) => setEmail(e.target.value)}
            />
            <CustomButton onClick={handleSubscribe}>
              <Typography mx={5}>Send</Typography>
            </CustomButton>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Donations;
